<template>
	<div id="top2">
		<div class="cc-header">实时课表</div>
		<dv-scroll-board :config="config" class="leavelist" />
	</div>
</template>

<script>
	var storage = window.localStorage;
	var orgId = storage.getItem("orgId");
	export default {
		data() {
			return {
				config: {},
				result: {},
				timeOutTimer: 0
			};
		},
		mounted() {
			this.initData();
			// 定时器刷新，3小时
			let _this = this;
			setInterval(() => {
				_this.initData(); // 修改数据date
			}, 1000 * 60 * 60 * 3);
		},
		methods: {
			initData() {
				let _this = this;
				this.$http.get("/dataView/headmaster/clazzTimetable?orgId=" + orgId).then(res => {
					if (res.data.code === 200) {
						_this.result = res.data;
						_this.refreshData();
					}
				});
			},
			refreshData(){
				let _this = this;
				var sectionArr = [];
				var nowTime = new Date().getTime();
				var nowDate = new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate();
				for (let k = 0; k < _this.result.restList.length; k++) {
					var section = {"clazzId":_this.result.restList[k].clazzId,"clazzName":_this.result.restList[k].clazzName};
					var sectionIdArr = _this.result.restList[k].sectionId.split(",");
					var sectionNameArr = _this.result.restList[k].sectionName.split(",");
					var startTimeArr = _this.result.restList[k].startTime.split(",");
					var endTimeArr = _this.result.restList[k].endTime.split(",");
					for (let i = 0; i < sectionIdArr.length; i++) {
						var startTime = new Date(nowDate + " " + startTimeArr[i] + ":00").getTime();
						var endTime = new Date(nowDate + " " + endTimeArr[i] + ":00").getTime();
						if(nowTime < startTime){
							if(i == 0){
								section.sectionId = sectionIdArr[i];
								section.sectionName = sectionNameArr[i];
								sectionArr.push(section);
								if(endTime - nowTime > 0){
									if(_this.timeOutTimer == 0 || (endTime - nowTime) < _this.timeOutTimer){
										_this.timeOutTimer = endTime - nowTime;
									}
								}
								break;
							}else{
								var preStartTime = new Date(nowDate + " " + startTimeArr[i-1] + ":00").getTime();
								var preEndTime = new Date(nowDate + " " + endTimeArr[i-1] + ":00").getTime();
								if(nowTime >= preStartTime && nowTime <= preEndTime){
									section.sectionId = sectionIdArr[i-1];
									section.sectionName = sectionNameArr[i-1];
									sectionArr.push(section);
									if(preEndTime - nowTime > 0){
										if(_this.timeOutTimer == 0 || (preEndTime - nowTime) < _this.timeOutTimer){
											_this.timeOutTimer = preEndTime - nowTime;
										}
									}
									break;
								}else{
									section.sectionId = sectionIdArr[i];
									section.sectionName = sectionNameArr[i];
									sectionArr.push(section);
									if(endTime - nowTime > 0){
										if(_this.timeOutTimer == 0 || (endTime - nowTime) < _this.timeOutTimer){
											_this.timeOutTimer = endTime - nowTime;
										}
									}
									break;
								}
							}
						}
					}
				}
				var result = [];
				for (let i = 0; i < sectionArr.length; i++) {
					var sectionName = sectionArr[i].sectionName;
					var clazzName = sectionArr[i].clazzName;
					var courseName = '<span style="color:#df8615;">暂无课程</span>';
					var teacherName = '';
					for (let k = 0; k < _this.result.dataList.length; k++) {
						var record = _this.result.dataList[k];
						if(sectionArr[i].sectionId == record.sectionId && sectionArr[i].clazzId == record.clazzId ){
							courseName = '<span style="color:#00f6ff;">'+record.courseName+'</span>';
							teacherName = record.teacherName;
							break;
						}
					}
					result.push([sectionName, clazzName, courseName, teacherName]);
				}
				if(result.length > 0){
					_this.config = {
						header: ['节次', '班级', '科目', '任课老师'],
						data: result,
						headerBGC: '',
						oddRowBGC: 'none',
						evenRowBGC: 'none',
						headerHeight: 30,
						rowNum: 5, //表格行数
						waitTime: 2000,
						align: ['center', 'center', 'center', 'center']
					};
				}else{
					_this.config = {
						data: [['<div class="noneData">暂未设置节次</div>']],
						evenRowBGC: 'none',
						rowNum: 1,
						align: ['center']
					};
				}
				//创建定时器
				if(_this.timeOutTimer > 0){
					console.log("距离下次刷新时间:" + Math.round(_this.timeOutTimer/1000) + "秒");
					setTimeout(() => {
						_this.refreshData();
					}, _this.timeOutTimer);
				}
			}
		}
	};
</script>

<style lang="scss">
	#top2 {
		height: 100%;
		.leavelist {
			padding: 0.2rem 0.1rem;
			width: 100%;
			height: 80%;
		}
		
		.leavelist .header {
			background: url("../../assets/img/hm_tblbg.png") center repeat-y;
			background-size: 100%;
			color: #00f0ff;
			font-size: 0.2rem;
			font-weight: bold;
		}
		
		.leavelist .row-item {
			background: url("../../assets/img/hm_tblbg.png") bottom no-repeat;
			background-size: 100%;
			color: #fff;
			font-size: 0.2rem;
		}
	}
</style>